import { BaseEntityDTO, IBaseEntityDTO, ITeamCriteriaDTO, TeamCriteriaDTO } from './';

export interface INoteDTO extends IBaseEntityDTO {
  title: string;
  content: string;
  teamCriteria?: ITeamCriteriaDTO;
  private: boolean;
  hide: boolean;
}

export class NoteDTO extends BaseEntityDTO implements INoteDTO {
  title: string;
  content: string;
  teamCriteria?: ITeamCriteriaDTO;
  private: boolean;
  hide: boolean;

  constructor(data?: Partial<NoteDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.title = data?.title ?? '';
    this.content = data?.content ?? '';
    this.private = data?.private ?? true;
    this.hide = data?.hide ?? false;
    this.teamCriteria = data?.teamCriteria
      ? new TeamCriteriaDTO(data.teamCriteria)
      : new TeamCriteriaDTO();
  }
}
